import Vue from 'vue'
import Toasted from 'vue-toasted'
import store from '@/store'

Vue.use(Toasted)

export default {
  methods: {
    checkDuplicateToast (msg) {
      let toastNodes = document.querySelectorAll('.toasted')
      for (let toast of toastNodes) {
        if (toast.innerText === msg) {
          toast.remove()
          break
        }
      }
    },
    errorToastMsg (msg) {
      this.checkDuplicateToast(msg)
      const icon = 'fa-exclamation-circle'
      this.showToast('error', msg, icon)
    },
    successToastMsg (msg, options = {}) {
      if (msg.toLowerCase() === 'success') {
        return
      }

      this.checkDuplicateToast(msg)
      const icon = 'fa-check-circle'
      let customClass = (options.isPublic || store.state.session.targetPage) !== 'ANY' ? 'public' : null
      this.showToast('success', msg, icon, customClass)
    },
    showToast (type, msg, icon, className = null) {
      Vue.toasted.show(msg, {
        type,
        iconPack: 'fontawesome',
        position: 'bottom-right',
        icon,
        className,
        action: {
          icon: 'fa-times',
          onClick: (event, toastObject) => {
            toastObject.goAway(0)
          }
        }
      }).goAway(5000)
    },
    isDesktop () {
      return this.$mq === 'desktop'
    }
  }
}
